import { images } from './assetUtilities';
export function appLauncherItems(labels) {
  const imagesAssets = images;
  const menuItems = [{
    name: labels.partnerCommunity,
    url: 'https://partners.salesforce.com',
    image: imagesAssets.partnerCommunityLogo,
    position: 0
  }, {
    name: labels.trailhead,
    url: 'https://trailhead.salesforce.com/auth/tbidlogin',
    image: imagesAssets.trailheadLogo,
    position: 1
  }, {
    name: labels.trailblazerCommunity,
    url: 'https://trailhead.salesforce.com/auth/tbidlogin?state=/trailblazer-community/feed',
    image: imagesAssets.trailblazerLogo,
    position: 2
  }, {
    name: labels.isvDevCenter,
    url: 'https://developer.salesforce.com/developer-centers/appexchange',
    image: imagesAssets.isvDevCenterLogo,
    position: 3
  }, {
    name: labels.salesforceHelp,
    url: 'https://help.salesforce.com/',
    image: imagesAssets.salesforceHelpLogo,
    position: 5
  }, {
    name: labels.events,
    url: 'https://trailblazer.salesforce.com/services/auth/sso/Login?startURL=/events',
    image: imagesAssets.eventsLogo,
    position: 4
  }];
  return addIdAppLauncheritem(menuItems.sort((prev, current) => prev.position > current.position ? 1 : -1));
}
function addIdAppLauncheritem(menuItems) {
  return menuItems.map((item, index) => {
    index++;
    return {
      ...item,
      id: index
    };
  });
}